module.exports = __webpack_public_path__ + "static/media/CC20-LC240-12.7d50f926.png";